import { useState } from "react";

export type FilterGroup = {
  key: string;
  label: string;
  options: string[];
};

type Props = {
  groups: FilterGroup[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  onReset: () => void;
};

export default function FilterBar({ groups, values, onChange, onReset }: Props) {
  const [openMobile, setOpenMobile] = useState(false);

  const body = (
    <div className="divide-y divide-background-200">
      {groups.map((g) => (
        <div key={g.key} className="flex flex-col md:flex-row gap-2 md:gap-4 py-3">
          <div className="md:w-20 shrink-0 text-sm font-medium text-foreground-700 leading-7">{g.label}</div>
          <div className="flex flex-wrap gap-2">
            {g.options.map((opt) => {
              const active = values[g.key] === opt;
              return (
                <button
                  key={opt}
                  type="button"
                  onClick={() => onChange(g.key, opt)}
                  className={`whitespace-nowrap px-3 py-1 rounded-md text-sm transition-colors cursor-pointer ${
                    active
                      ? "bg-accent-500 text-primary-950 font-semibold"
                      : "bg-background-100 text-foreground-600 hover:bg-accent-100 hover:text-accent-800"
                  }`}
                >
                  {opt}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <div className="md:hidden mb-1">
        <button
          type="button"
          onClick={() => setOpenMobile((v) => !v)}
          className="w-full flex items-center justify-between py-1 cursor-pointer"
        >
          <span className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
            <i className="ri-filter-3-line text-lg text-accent-500"></i>
            筛选条件
          </span>
          <i className={openMobile ? "ri-arrow-up-s-line text-xl text-foreground-500" : "ri-arrow-down-s-line text-xl text-foreground-500"}></i>
        </button>
      </div>

      <div className={`${openMobile ? "block" : "hidden"} md:block`}>{body}</div>

      <div className="mt-3 pt-3 border-t border-background-200 flex justify-end">
        <button
          type="button"
          onClick={onReset}
          className="whitespace-nowrap inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-secondary-300 text-secondary-800 text-sm hover:bg-secondary-100 transition-colors cursor-pointer"
        >
          <i className="ri-refresh-line"></i>
          重置筛选
        </button>
      </div>
    </div>
  );
}